import { apiRequest } from './client';

export function fetchWorkspaceUsers(token, { status = 'all' } = {}) {
  const query = new URLSearchParams();
  if (status && status !== 'all') {
    query.set('status', status);
  }
  const qs = query.toString();
  return apiRequest(`/admin/workspace-users${qs ? `?${qs}` : ''}`, token);
}

export function fetchWorkspaceUser(token, userId) {
  return apiRequest(`/admin/workspace-users/${userId}`, token);
}

export function createWorkspaceUser(token, input) {
  return apiRequest('/admin/workspace-users', token, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function updateWorkspaceUser(token, userId, input) {
  return apiRequest(`/admin/workspace-users/${userId}`, token, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}

export function resendWorkspaceUserInvite(token, userId) {
  return apiRequest(`/admin/workspace-users/${userId}/resend-invite`, token, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}
